import React from "react"
export function MultipleAirlines(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M18.435 6.91l.028.028a1.052 1.052 0 010 1.452l-2.881 3.015 1.8 5.094a.453.453 0 01-.05.404l-.055.066-1.09 1.095-2.713-4.452-2.74 2.868.485 1.215a.453.453 0 01-.05.428l-.049.058-.815.819-1.288-2.01-2-1.294.815-.82a.447.447 0 01.484-.099l.92.37 2.85-2.984L7.57 9.382l1.04-1.11a.447.447 0 01.476-.117l5.091 1.818 2.9-3.035a.958.958 0 011.358-.028zm-5.767-5.641l.028.028a1.052 1.052 0 010 1.452L9.814 5.764l.685 1.938-1.112-.397a1.342 1.342 0 00-1.432.349L6.161 9.57l.01.006-1.204 1.262.485 1.215a.453.453 0 01-.05.428l-.05.058-.814.82-1.288-2.01-2-1.295.815-.819a.447.447 0 01.484-.1l.919.37 2.85-2.983-4.566-2.81 1.09-1.096a.447.447 0 01.468-.106l5.1 1.82 2.9-3.034a.958.958 0 011.358-.028z"
        fill="currentColor"
        id="prefix__multiple-airlines"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
